// extracted by mini-css-extract-plugin
export default {"root":"ProductVideoTab_root__kxSFY","video":"ProductVideoTab_video__+xXic"};